import React from "react";
import styles from "../../styles/presentational/footer.css";

export class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.faq}>
          <a
            className={styles.link}
            href={this.props.links.footer_faq}
            target="_blank"
          >
            {this.props.dictionary.footer_faq}
          </a>
        </div>
        <div className={styles.label}>
          {this.props.dictionary.footer_contact}
        </div>
        <div className={styles.contact}>
          <div className={styles.phone}>
            <a className={styles.link} href={this.props.links.footer_phone}>
              {this.props.dictionary.footer_phone}
            </a>
          </div>
          |
          <div className={styles.email}>
            <a className={styles.link} href={this.props.links.footer_email}>
              {this.props.dictionary.footer_email}
            </a>
          </div>
        </div>
        <div className={styles.message}>
          {this.props.dictionary.footer_message}
        </div>
        {this.props.dictionary.footer_register ? (
          <div className={styles.register}>
            &reg;&nbsp;{this.props.dictionary.footer_register}
          </div>
        ) : null}
      </footer>
    );
  }
}
